<template>
    <div class="row page-row report">
        <b-modal
            id="report-download-modal"
            ref="reportDownloadModal"
            title="Download report"
            ok-title="Download"
            size="md"
            @ok="downloadReport"
            @cancel="closeDownloadModal">
            <b-form>
                <b-form-group label="Please select the report file format" class="pt-3" v-slot="{ ariaDescribedby }">
                    <label class="report-label">
                        <b-form-radio
                            inline
                            value="pdf"
                            v-model="report.type"
                            name="report-download-type"
                            :aria-describedby="ariaDescribedby">
                            <strong>PDF</strong>
                        </b-form-radio>
                    </label>

                    <label class="report-label">
                        <b-form-radio
                            inline
                            value="docx"
                            v-model="report.type"
                            name="report-download-type"
                            :aria-describedby="ariaDescribedby">
                            <strong>Word</strong>

                            <b-icon-info-circle-fill
                                v-b-tooltip
                                class="ml-1 text-muted"
                                title="Microsoft Word or compatible software is required to view the file."/>
                        </b-form-radio>
                    </label>

                    <label class="report-label">
                        <b-form-radio
                            inline
                            value="xlsx"
                            v-model="report.type"
                            name="report-download-type"
                            :aria-describedby="ariaDescribedby">
                            <strong>Excel</strong>

                            <b-icon-info-circle-fill
                                v-b-tooltip
                                class="ml-1 text-muted"
                                title="Microsoft Excel or compatible software is required to view the file."/>
                        </b-form-radio>
                    </label>
                </b-form-group>
            </b-form>
        </b-modal>

        <b-modal
            id="report-combine-modal"
            ref="reportCombineModal"
            title="Combine reports"
            ok-title="Combine"
            size="md"
            @ok="combineSelectedReports"
            @cancel="$refs.reportCombineModal.hide()">
            <p>You are about to combine the selected {{ selectedReports.length }} reports.</p>
            <p>A new report will be created. Do you wish to continue?</p>
        </b-modal>

        <div class="col-sm-3 reports full-inner-page">

            <div class="menu-bar clearfix">
                <div id="report-info-menu-bar-title" class="pull-left">
                    <h2>Report List</h2>
                </div>

                <div class="report-dropdown pull-right">
                    <b-button-group>

                        <b-button variant="none" size="lg" pill style="padding: 0;margin: 0;" @click="loadReports">
                            <b-icon icon="arrow-clockwise" class="rounded-circle bg-danger text-white"></b-icon>
                        </b-button>

                        <div class="dropdown">
                            <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
                                <template #button-content>
                                    <b-icon icon="justify" size="sm" class="rounded-circle bg-danger text-white"/>
                                </template>

                                <b-dropdown-header>Filter</b-dropdown-header>

                                <b-dropdown-item :active="!activeUser" @click="activeUser = null">
                                    All reports
                                </b-dropdown-item>

                                <b-dropdown-item
                                    v-for="user in users"
                                    :key="user.id"
                                    :active="activeUser && user.id === activeUser.id "
                                    @click="activeUser = user">
                                    {{ user.name }}
                                </b-dropdown-item>

                                <template v-if="hasManagerPermission('reports.edit')">
                                    <b-dropdown-divider/>
                                    <b-dropdown-header>Actions</b-dropdown-header>

                                    <li>
                                        <report-import v-on:reportImported="reportImported"/>
                                    </li>

                                    <!--                                     <b-dropdown-item
                                                                            v-if="!allowCombineReports"
                                                                            class="combine-report-button btn copy"
                                                                            @click="allowCombineReports = true">
                                                                            Combine reports
                                                                        </b-dropdown-item>

                                                                        <b-dropdown-item
                                                                            v-else
                                                                            class="combine-report-button btn-stop"
                                                                            @click="allowCombineReports = false; selectedReports = []">
                                                                            <b-icon-x-circle-fill/>
                                                                            Exit combining reports
                                                                        </b-dropdown-item>-->
                                </template>
                            </b-dropdown>
                        </div>

                    </b-button-group>
                </div>
            </div>

            <ul class="list-unstyled" v-if="reportsLoaded">

                <template v-for="report in reports">

                    <router-link tag="li" v-if="showReport(report)" :key="report.id"
                                 :class="{ generating: isReportBeingGenerated(report) }"
                                 :to="{ name: 'projects-reports-view', params: { id: $route.params.id, report_id: report.id }}">
                        {{ reportTitle(report) }}

                        <div v-if="isReportBeingGenerated(report)" class="projects-reports-view-spinner">
                            <b-spinner variant="danger" small></b-spinner>
                        </div>

                        <b-button
                            v-if="isReportBeingGenerated(report)"
                            :disabled="!hasManagerPermission('reports.delete')"
                            v-on:click="cancelReport"
                            v-b-tooltip.hover
                            title="Cancel"
                            class="rounded-circle text-white delete-button"
                            size="sm"
                        >
                            <b-icon icon="x-circle" scale="2" variant="danger"></b-icon>
                        </b-button>

                        <div class="reportCheck"
                             v-if="!isReportBeingGenerated(report) && !report.is_combined_report && allowCombineReports">
                            <b-icon-check-square
                                v-if="selectedReports.includes(report.id)"
                                @click.stop.prevent="selectedReports = selectedReports.filter(reportId => reportId !== report.id)">
                            </b-icon-check-square>
                            <b-icon-square v-else @click.stop.prevent="selectedReports.push(report.id)"></b-icon-square>
                        </div>

                        <div class="report-bottom-section">
                            <div
                                v-if="isReportBeingGenerated(report) && report.generating_percentage"
                                class="progress"
                            >
                                <div
                                    class="progress-bar progress-bar-striped progress-bar-animated"
                                    role="progressbar"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                    :aria-valuenow="report.generating_percentage"
                                    :style="{ width: report.generating_percentage + '%' }"
                                >
                                    <span class="sr-only"></span>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </template>
            </ul>
            <div class="d-flex justify-content-center mb-3" v-else-if="!reportsLoaded">
                <b-spinner label="Loading..." variant="danger"/>
            </div>
        </div>


        <div class="col-sm-6 document full-inner-page reports-index-preview" ref="scrollable">
            <template v-if="activeReport">
                <Report :source="activeReport"
                />
            </template>
        </div>


        <div class="col-sm-2 markings">
            <template v-if="activeReport">
                <h6 class="mt-2 mb-3 ml-1">Markings</h6>

                <div v-for="(type, typeIndex) in typeNames"
                     v-if="shouldShowGroup(type)"
                     class="accordion mb-1"
                     :key="`type-${typeIndex}`">
                    <div class="card">
                        <div class="card-header" :id="`collapse-${type}-${typeIndex}-header`">
                            <h3 class="mb-0">
                                <button class="btn btn-link"
                                        type="button"
                                        :data-target="`collapse-${type}-${typeIndex}`"
                                        v-b-toggle="`collapse-${type}-${typeIndex}`"
                                        :aria-controls="`collapse-${type}-${typeIndex}`"
                                        aria-expanded="true"
                                        @click.stop>
                                    <span class="collapse-header-title" v-text="types[type]"></span>
                                    <b-checkbox
                                        class="collapse-header-checkbox"
                                        v-model="typeCheckboxes[type].allSelected"
                                        :indeterminate="typeCheckboxes[type].indeterminate"
                                        @change="state => toggleAllByType(type, state)"
                                        @click.native.stop=''/>
                                </button>
                            </h3>
                        </div>

                        <b-collapse :id="`collapse-${type}-${typeIndex}`"
                                    :aria-labelledby="`collapse-${type}-${typeIndex}-header`"
                                    visible>
                            <b-card>
                                <b-form-checkbox-group id="reports-index-marking-ids"
                                                       v-model="report.markingIds"
                                                       name="reports-index-marking-ids">
                                    <template v-if="type === 'firestop' || type === 'custom'">
                                        <div v-for="(titleGroup, title, titleIndex) in groupMarkingsByTitle(type)"
                                             :key="`title-${type}-${titleIndex}`"
                                             class="accordion">
                                            <div class="card">
                                                <div class="card-header" :id="`collapse-${type}-${titleIndex}-header`">
                                                    <h4 class="mb-0">
                                                        <button class="btn btn-link"
                                                                type="button"
                                                                :data-target="`collapse-${type}-${titleIndex}`"
                                                                v-b-toggle="`collapse-${type}-${titleIndex}`"
                                                                :aria-controls="`collapse-${type}-${titleIndex}`"
                                                                @click.stop>
                                                            <span class="collapse-header-title" v-text="title || 'Untitled'"></span>
                                                        </button>
                                                    </h4>
                                                </div>

                                                <b-collapse :id="`collapse-${type}-${titleIndex}`"
                                                            :aria-labelledby="`collapse-${type}-${titleIndex}-header`"
                                                            visible>
                                                    <b-card>
                                                        <ul class="list-unstyled" :class="type + '-list'">
                                                            <li v-for="(marking, markingIndex) in titleGroup"
                                                                :key="`marking-${markingIndex}`"
                                                                class="d-flex"
                                                                @click="scrollToMarking(marking)"
                                                                :class="{
                                                            'mod-checked': marking.is_checked,
                                                            'disabled-marking': activeReport.report_type === 1 && (!marking.groupped_attachments || marking.groupped_attachments.length === 0)
                                                        }">

                                                                <template v-if="type === 'firestop' && marking.tool">
                                                                    <CustomMarkingIcon
                                                                        class="firestopMarkingIcon"
                                                                        :bottom-text="marking.tool.show_lower_detail ? marking.markingPrefix : null"
                                                                        :marking-color="marking.catalog_1 || marking.tool.color || '#000000'"
                                                                        :middle-text="marking.markingIndex.toString()"
                                                                        :top-text="marking.tool.show_upper_detail ? marking.text_1 : null"
                                                                    ></CustomMarkingIcon>
                                                                </template>

                                                                <template v-else-if="type === 'custom' && marking.tool">
                                                                    <FirestopMarkingIcon
                                                                        class="firestopMarkingIcon"
                                                                        :bottom-text="marking.tool.show_lower_detail ? marking.markingPrefix : null"
                                                                        :marking-color="marking.catalog_1 || marking.tool.color || '#000000'"
                                                                        :middle-text="marking.markingIndex.toString()"
                                                                        :top-text="marking.tool.show_upper_detail ? marking.catalog_2 : null"
                                                                    ></FirestopMarkingIcon>
                                                                </template>

                                                                <span v-text="markingLabel(marking)"></span>

                                                                <b-form-checkbox
                                                                    class="ml-auto mr-0"
                                                                    variant="danger"
                                                                    :value="marking.id"
                                                                    @change="markingToggled(marking, type)"
                                                                    @click.native.stop=''/>
                                                            </li>
                                                        </ul>
                                                    </b-card>
                                                </b-collapse>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-else>
                                        <ul class="list-unstyled" :class="type + '-list'">
                                            <li v-for="(marking, markingIndex) in markingsByType(type)"
                                                :key="`marking-${markingIndex}`"
                                                class="d-flex"
                                                @click="scrollToMarking(marking)"
                                                :class="{
                                            'mod-checked': marking.is_checked,
                                            'disabled-marking': activeReport.report_type === 1 && (!marking.groupped_attachments || marking.groupped_attachments.length === 0)
                                        }">
                                                <span v-text="markingLabel(marking)"></span>
                                                <b-form-checkbox
                                                    class="ml-auto mr-0"
                                                    variant="danger"
                                                    :value="marking.id"
                                                    @change="markingToggled(marking, type)"
                                                    @click.native.stop=''/>
                                            </li>
                                        </ul>
                                    </template>
                                </b-form-checkbox-group>
                            </b-card>
                        </b-collapse>
                    </div>
                </div>
            </template>
        </div>

        <div class="col-sm-1 icons d-flex flex-column actions align-items-stretch"
             v-if="activeReport || selectedReports.length > 1">

            <template v-if="activeReport">
                <button v-if="allowCombineReports "
                        class="btn copy"
                        :disabled="!(selectedReports.length > 1)"
                        v-b-modal.report-combine-modal
                        v-b-tooltip.hover.left
                        title="Combine selected reports (select 2 or more)">
                </button>

                <button
                    v-if="!allowCombineReports"
                    :disabled="downloadDisabled || isActiveReportBeingGenerated"
                    class="btn download"
                    v-b-modal.report-download-modal
                    v-b-tooltip.hover.left
                    title="Download">
                </button>


                <!--                TODO: re-enable this when congrid must be enabled-->
                <!--                <button v-if="$store.state.project.congrid_project_id"-->
                <!--                        class="btn convert"-->
                <!--                        v-b-tooltip.hover.left-->
                <!--                        @click="uploadToCongrid"-->
                <!--                        :disabled="isReportBeingGenerated(activeReport)"-->
                <!--                        title="Upload to Congrid">-->
                <!--                </button>-->

                <router-link
                    v-if="hasManagerPermission('reports.edit') && !activeReport.is_combined_report"
                    :to="{ name: 'projects-report-edit-view', params: { id: $store.state.project.id, report_id: activeReport.id }}"
                    class="btn edit"
                    v-b-modal.report-download-modal
                    v-b-tooltip.hover.left
                    title="Edit">
                </router-link>

                <button :disabled="!hasManagerPermission('reports.delete')"
                        class="btn delete"
                        @click="deleteReport"
                        v-b-tooltip.hover.left
                        title="Delete">
                </button>
            </template>
        </div>
    </div>
</template>

<script>
import '@css/report.css';
import {each, filter, isEmpty, isNull, keys, map, reject, sortBy, uniqBy} from 'lodash';
import Report from '@mobile/components/report/Report';
import FirestopMarkingIcon from "@mobile/components/global/Markings/FirestopMarkingIcon";
import CustomMarkingIcon from "@mobile/components/global/Markings/CustomMarkingIcon";
import EventBus from "@mobile/utils/event-bus";
import ReportImport from "./parts/ReportImport";
import moment from 'moment';
import axios from "axios";

export default {
    components: {ReportImport, Report, FirestopMarkingIcon, CustomMarkingIcon},
    data() {
        return {
            reports: [],
            reportsAreLoading: false,
            reportsLoaded: false,
            activeReport: null,
            activeUser: null,
            types: {
                camera: "Camera",
                measure: "Measurements",
                gallery: "Gallery",
                note: "Notes",
                draw: "Drawings",
                checkbox: "Checkbox",
                firestop: "Firestop",
                custom: "Custom",
            },
            typeCheckboxes: {
                camera: {
                    allSelected: true,
                    indeterminate: false
                },
                measure: {
                    allSelected: true,
                    indeterminate: false
                },
                gallery: {
                    allSelected: true,
                    indeterminate: false
                },
                note: {
                    allSelected: true,
                    indeterminate: false
                },
                draw: {
                    allSelected: true,
                    indeterminate: false
                },
                checkbox: {
                    allSelected: true,
                    indeterminate: false
                },
                firestop: {
                    allSelected: true,
                    indeterminate: false
                },
                custom: {
                    allSelected: true,
                    indeterminate: false
                }
            },
            report: {
                type: 'docx',
                markingIds: [],
                created_by: {
                    id: null
                },
                is_report_generated: false
            },

            generating: [],
            downloadDisabled: false,
            selectedReports: [],
            allowCombineReports: false
        }
    },
    watch: {

        activeReport: function (activeReport) {
            if (!activeReport) {
                return;
            }

            this.report.markingIds = [];

            each(activeReport.markings, (marking) => {
                this.report.markingIds.push(marking.id);
            });

            Object.keys(this.typeCheckboxes).forEach(type => {
                this.typeCheckboxes[type].allSelected = true;
                this.typeCheckboxes[type].indeterminate = false;
            });
        },
    },
    computed: {
            shouldShowGroup() {
                return (type) => {
                    if (this.activeReport.report_type === 1) {
                        return this.markingsByType(type).some(marking =>
                            marking.groupped_attachments && marking.groupped_attachments.length > 0
                        );
                    }
                    return this.markingsByType(type).length > 0;
                };
            },

        isActiveReportBeingGenerated() {
            return this.activeReport && (this.generating.indexOf(this.activeReport.id) !== -1 || this.activeReport.is_report_generated !== 1);
        },
        users() {
            return sortBy(
                uniqBy(
                    reject(
                        map(this.reports, (report) => report.created_by),
                        isNull
                    ),
                    'id'
                ),
                ['name'],
                ['asc']
            );
        },
        typeNames: function () {
            return keys(this.types);
        }
    },
    beforeRouteEnter: function (to, from, next) {
        next(function (vm) {
            vm.updateActiveReport();
        });
    },
    beforeRouteUpdate: function (to, from, next) {
        next();

        this.updateActiveReport();
    },
    async created() {
        if (!this.$store.state.project.id || !this.$store.state.company.id) {
            this.$store.state.project.id = localStorage.getItem('project_id');
            this.$store.state.company.id = localStorage.getItem('company_id');
        }

        this.$store.state.company = await this.$store.dispatch('loadCompany');
        this.$store.state.project = await this.$store.dispatch('loadProject', this.$store.state.project.id);

        await this.loadReports();

        this.projectRefreshInterval = setInterval(this.loadReports, 10 * 1000); // 10 seconds
    },
    beforeRouteLeave(to, from, next) {
        if (this.projectRefreshInterval && to.name !== 'projects-reports-view' && to.name !== 'projects-reports-index') {
            clearInterval(this.projectRefreshInterval);
        }

        next();
    },
    methods: {
        markingToggled(marking, type) {
            const markingsByType = this.markingsByType(type);

            this.$nextTick(() => {
                const selected = markingsByType.filter(marking => {
                    const index = this.report.markingIds.findIndex(id => id === marking.id);
                    return index > -1;
                });

                if (markingsByType.length === selected.length) {
                    this.typeCheckboxes[type].allSelected = true;
                    this.typeCheckboxes[type].indeterminate = false;
                } else if (selected.length && (selected.length < markingsByType.length)) {
                    this.typeCheckboxes[type].allSelected = false;
                    this.typeCheckboxes[type].indeterminate = true;
                } else if (selected.length === 0) {
                    this.typeCheckboxes[type].allSelected = false;
                    this.typeCheckboxes[type].indeterminate = false;
                }

                this.$forceUpdate();
            });
        },

        toggleAllByType(type, state) {
            this.$nextTick(() => {
                this.markingsByType(type).forEach(marking => {
                    const index = this.report.markingIds.findIndex(id => id === marking.id);

                    if (state) {
                        if (index === -1) {
                            this.report.markingIds.push(marking.id);
                        }
                    } else {
                        if (index > -1) {
                            this.report.markingIds.splice(index, 1);
                        }
                    }
                });

                this.typeCheckboxes[type].allSelected = state;
                this.typeCheckboxes[type].indeterminate = false;
            });
        },
        isReportBeingGenerated(report) {
            return this.generating.indexOf(report.id) !== -1 || report.is_report_generated !== 1;
        },

        showReport(report) {
            return report.file && (
                !this.activeUser ||
                (report.created_by && report.created_by.id === this.activeUser.id)
            );
        },

        async loadReports() {
            if (!this.$store.state.project.id || !this.$store.state.company.id) {
                await this.$router.push('/');
            }

            if (this.reportsAreLoading) {
                return;
            }

            this.reportsAreLoading = true;

            this.reports = await this.$store.dispatch('loadReports').catch((err) => {
                this.reportsAreLoading = false;
                console.log('error loading reports', err);
            });

            if (this.activeReport) {
                const updatedReport = this.reports.find(r => r.id === this.activeReport.id);
                if (updatedReport) {
                    this.activeReport.is_report_generated = updatedReport.is_report_generated;
                    this.activeReport.generating_percentage = updatedReport.generating_percentage;

                    if (updatedReport.is_report_generated === 1) {
                        this.downloadDisabled = false;
                        this.activeReport.docx_url = updatedReport.docx_url;
                        this.activeReport.pdf_url = updatedReport.pdf_url;
                    }
                }
            }

            this.updateActiveReport();
            this.reportsLoaded = true;
            this.reportsAreLoading = false;
        },

        updateActiveReport: function () {

            if (isEmpty(this.reports)) {
                this.activeReport = null;
                return;
            }

            let reportId = parseInt(this.$route.params.report_id);

            if (!reportId || (this.activeReport && this.activeReport.id === reportId)) {
                return;
            }

            this.activeReport = null;

            this.$nextTick(async () => {
                this.activeReport = await this.$store.dispatch('loadReport', reportId);
                this.activeReport.company = this.$store.state.company;
                this.activeReport.project = this.$store.state.project;

                if (this.activeReport.is_combined_report) {
                    this.activeReport.pages = [];
                    this.activeReport.markings = [];
                    this.activeReport.preview_combine_reports.forEach((item) => {
                        item.markings.forEach((mark) => {
                            item.pages.forEach((page) => {
                                page.report_id = mark.report_id;
                            })
                        })
                        this.activeReport.pages = this.activeReport.pages.concat(item.pages);
                        this.activeReport.markings = this.activeReport.markings.concat(item.markings);
                    });
                } else {

                    this.activeReport.markings.forEach((mark) => {
                        this.activeReport.pages.forEach((page) => {
                            page.report_id = mark.report_id;
                        })
                    })
                }
            });
        },

        markingsByType(type) {
            if (!this.activeReport) {
                return [];
            }

            return filter(this.activeReport.markings, (marking) => {
                return marking.type === type;
            });
        },

        groupMarkingsByTitle(type) {
            const markings = this.markingsByType(type);
            return markings.reduce((groups, marking) => {
                const title = marking.title || '';
                if (!groups[title]) {
                    groups[title] = [];
                }
                groups[title].push(marking);
                return groups;
            }, {});
        },

        scrollToMarking(marking) {
            const el = document.querySelector('#marking-' + marking.id);

            if (el) {
                this.$refs.scrollable.scrollTo({
                    top: el.offsetTop - 30,
                    behavior: 'smooth'
                });
            }
        },

        closeDownloadModal() {
            this.$refs.reportDownloadModal.hide();
        },

        dateToYMD(date) {
            return moment(date).format('DD-MM-YYYY HH:mm');
        },
        markingLabel(marking) {
            return this.markingPrefix(marking) + '_' + this.markingIndex(marking) + (marking.title ? ' - ' + marking.title : '');
        },
        markingIndex(marking) {
            let index = marking.markingIndex;
            if (marking.created_by && marking.created_by.unique_id && ('' + marking.created_by.unique_id).length) {
                index += ':' + marking.created_by.unique_id;
            } else if (this.$store.state.company && this.$store.state.company.unique_user_id) {
                index += ':' + this.$store.state.company.unique_user_id;
            }

            return index;
        },
        markingPrefix(marking) {
            if (marking.tool && (marking.type === 'custom' || marking.type === 'firestop')) {
                if (marking.tool && marking.tool.short_name) {
                    return marking.tool.short_name;
                } else if (marking.project_marking_tool_id) {
                    const tool = this.projectTools.find(tool => tool.id === marking.project_marking_tool_id);
                    if (tool) {
                        return tool.short_name;
                    }
                }
            }

            if (marking.type === 'checkbox') {
                if (marking.is_checked) {
                    return 'OK';
                }
                return 'NOK';
            }

            return marking.markingPrefix;
        },

        downloadFile: function (url, filename) {
            // use HTML5 a[download] attribute to specify filename
            let a = document.createElement("a");
            // safari doesn't support this yet
            if (typeof a.download === 'undefined') {
                window.location = url;
            } else {
                a.target = '_blank';
                a.href = url;
                a.download = filename;
                a.click();
            }
        },

        generateReport(url, payload = {}) {

            this.downloadDisabled = true;

            EventBus.$emit('SHOW_LOADER', {
                title: "Your report is currently being generated",
                message: "As soon as it's finished you will be able to download it. Please wait and do not leave this screen."
            });

            return new Promise((resolve, reject) => {
                const self = this;
                const xhr = new XMLHttpRequest();

                xhr.open('POST', url, true);
                xhr.responseType = 'arraybuffer';
                xhr.onload = function () {
                    if (this.status === 200) {
                        let filename = "";
                        let disposition = xhr.getResponseHeader('Content-Disposition');

                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            let matches = filenameRegex.exec(disposition);

                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                            }
                        }

                        let type = xhr.getResponseHeader('Content-Type');
                        let blob = new Blob([this.response], {type: type});

                        EventBus.$emit('HIDE_LOADER');
                        this.downloadDisabled = false;

                        if (typeof window.navigator.msSaveBlob !== 'undefined') {
                            // IE workaround for "HTML7007: One or more blob URLs were
                            // revoked by closing the blob for which they were created.
                            // These URLs will no longer resolve as the data backing
                            // the URL has been freed."
                            window.navigator.msSaveBlob(blob, filename);
                        } else {
                            let URL = window.URL || window.webkitURL;
                            let downloadUrl = URL.createObjectURL(blob);

                            if (filename) {
                                self.downloadFile(downloadUrl, filename);
                            } else {
                                window.location = downloadUrl;
                            }

                            setTimeout(function () {
                                URL.revokeObjectURL(downloadUrl);
                            }, 100); // cleanup
                        }

                        resolve(true);
                    }
                };

                xhr.onerror = function () {
                    reject(new Error('Unable to download the report!'));
                    EventBus.$emit('HIDE_LOADER');
                    this.downloadDisabled = false;
                    alert('Unable to download report. Please try again.');
                };

                xhr.setRequestHeader('Content-Type', 'application/json');
                xhr.send(JSON.stringify(payload));
            });
        },

        downloadReport() {
            if (!this.activeReport || !this.activeReport.id) {
                return;
            }

            if (this.report.markingIds.length === 0) {
                this.$bvModal.msgBoxOk('Please select at least one marking.', {
                    title: 'Markings not selected',
                    size: 'md',
                    buttonSize: 'md',
                    okVariant: 'danger',
                    centered: true
                });

                return;
            }

            const type = this.report.type; // Report type / file extension (docx|xlsx|pdf)
            let filename = this.activeReport[type + '_file_name'] || Date.now() + '.' + type;
            let url = this.activeReport[type + '_url'];
            let generate = !url;
            let payload = {filters: {}};


            const generationUrl = this.$store.state.apiURL + 'reports/' + this.activeReport.token;
            // Generate always new file if there are markings and not all of them are selected for the exported report.
            if (this.activeReport.markings.length !== this.report.markingIds.length) {
                generate = true;
                payload.filters.markings = this.report.markingIds;
                payload.report_type = this.activeReport.report_type;
            }
            if (generate) {
                let id = this.activeReport.id;

                url = generationUrl + '.' + type;

                this.generating.push(id);

                this.generateReport(url, payload)
                    .finally(() => {
                        const index = this.generating.indexOf(id);

                        if (index !== -1) {
                            this.generating.splice(index, 1);
                        }
                    })
            } else {
                this.downloadFile(url, filename);
            }

            this.closeDownloadModal();
        },
        deleteReport() {
            this.$bvModal.msgBoxConfirm('Are you sure you want to delete this report?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'md',
                okVariant: 'danger',
                okTitle: 'Delete',
                cancelTitle: 'Cancel',
                hideHeaderClose: true,
                centered: true
            })
                .then(value => {
                    if (value) {
                        this.$store.dispatch('APIdeleteReport', this.activeReport.id).then(res => {

                            // Prevent delete action on report related with combined report.
                            if (res.errors) {
                                this.$bvModal.msgBoxOk(res.errors, {
                                    title: 'Error',
                                    size: 'md',
                                    buttonSize: 'md',
                                    okVariant: 'danger',
                                    centered: true
                                });
                                return;
                            }

                            this.loadReports();

                            this.$bvModal.msgBoxOk('Report was deleted successfully.', {
                                title: 'Report deleted',
                                size: 'md',
                                buttonSize: 'md',
                                okVariant: 'danger',
                                centered: true
                            });

                        }).catch(err => {
                            this.$bvModal.msgBoxOk('Failed to delete report. Are you assigned to this project?', {
                                title: 'Error',
                                size: 'md',
                                buttonSize: 'md',
                                okVariant: 'danger',
                                centered: true
                            });
                        });
                    }
                })
                .catch(err => {
                    this.$bvModal.msgBoxOk('Failed to delete report.', {
                        title: 'Error',
                        size: 'md',
                        buttonSize: 'md',
                        okVariant: 'danger',
                        centered: true
                    });
                })
        },

        reportTitle(report) {
            let title = '';
            if (report.title) {
                title = report.title;
            } else {
                title = 'Untitled';
            }

            if (report.title_version) {
                title += ' (' + report.title_version + ')';
            }

            title += ' - ' + this.dateToYMD(report.created_at);

            return title;
        },
        reportImported(report) {
            this.loadReports().then(() => {
                this.$router.push({
                    name: 'projects-reports-view',
                    params: {id: this.$route.params.id, report_id: report.id}
                });
            });

        },
        uploadToCongrid() {
            let token = this.$store.state.token;

            axios({
                url: this.$store.getters.apiProjectBase + '/congrid/report-upload/' + this.activeReport.id,
                method: 'POST',
                data: {
                    congrid_project_id: this.selectedCongridProject
                },
                headers: {"Authorization": "Bearer " + token}
            })
                .then(response => {
                    this.$bvModal.msgBoxOk('Report was uploaded successfully.', {
                        title: 'Congrid Sync',
                        size: 'md',
                        buttonSize: 'md',
                        okVariant: 'danger',
                        centered: true
                    });
                })
                .catch(error => {
                    this.$bvModal.msgBoxOk('Failed to upload report.', {
                        title: 'Error',
                        size: 'md',
                        buttonSize: 'md',
                        okVariant: 'danger',
                        centered: true
                    });
                });
        },
        cancelReport() {
            this.$bvModal.msgBoxConfirm('Are you sure you want to cancel this report?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'md',
                okVariant: 'danger',
                okTitle: 'Proceed',
                cancelTitle: 'Cancel',
                hideHeaderClose: true,
                centered: true
            })
                .then(value => {
                    if (value) {
                        this.$store.dispatch('APIcancelReport', this.activeReport.id).then(res => {

                            this.loadReports();

                            this.$bvModal.msgBoxOk('Report was canceled successfully.', {
                                title: 'Report canceled',
                                size: 'md',
                                buttonSize: 'md',
                                okVariant: 'danger',
                                centered: true
                            });

                        }).catch(err => {
                            this.$bvModal.msgBoxOk('Failed to cancel report. Are you assigned to this project?', {
                                title: 'Error',
                                size: 'md',
                                buttonSize: 'md',
                                okVariant: 'danger',
                                centered: true
                            });
                        });
                    }
                })
                .catch(err => {
                    this.$bvModal.msgBoxOk('Failed to cancel report.', {
                        title: 'Error',
                        size: 'md',
                        buttonSize: 'md',
                        okVariant: 'danger',
                        centered: true
                    });
                })

        },

        combineSelectedReports() {

            if (this.selectedReports && this.selectedReports.length < 2) {
                alert('You must select at least two reports.');
                return;
            }
            let token = this.$store.state.token;

            axios({
                url: this.$store.getters.apiProjectBase + '/reports/combine',
                method: 'POST',
                data: {
                    reports: this.selectedReports,
                    type: this.report.type
                },
                headers: {"Authorization": "Bearer " + token}
            })
                .then(response => {
                    this.$refs.reportCombineModal.hide();
                    this.selectedReports = [];
                    this.loadReports();
                    this.allowCombineReports = false;
                })
                .catch(error => {
                    console.log(error);
                    alert('Something went wrong');
                    this.allowCombineReports = false;
                });
        }

    }
}
</script>

<style scoped>
.disabled-marking {
    pointer-events: none;
    opacity: 0.2;
}

.markings {
    .card-header h3 {
        background-color: #f0f0f0;
        border-radius: 3px;

        &:hover {
            background-color: #e7e7e7;
        }
    }
}

.reports-index-preview {
    overflow-x: auto;
    overflow-y: scroll;
}

.report-label {
    display: inline;
    background: #eee;
    border-radius: 10px;
    padding: 11px 0 10px 12px;
    margin-right: 6px;
    user-select: none;
    font-weight: normal;
}
</style>
